import React, { Component } from 'react'

import Avatar from '../../../../atoms/Avatar'
import ActionBtnIcon from '../../../../molecules/ActionBtnIcon'
import ActionBtn from '../../../../atoms/ActionBtn'

import T from '../../../../translate/T'


import { dateTimeFormat } from '../../../../helpers/Formatter'

import style from './style.css'
export default class Boxtext extends Component {
    state = {
        loadingApprove: false
    }

    render() {
        let data = this.props.data
        return(
            <div className={style.header}>
                <div className={style.avatar}>
                    <a href={`/${data.user_uri}`}>
                        <Avatar size={30} img={data.user_avatar !== '' ? `${window.URL_ASSETS_BASE}${data.user_avatar}` :  ''} />
                    </a>
                </div>
                <div className={style.name}>
                    {data.user_name}
                    <br />
                    <div className={style.time}>
                        {dateTimeFormat(T.txt('c_date_hour_format'), data.published_at)}
                    </div>
                </div>
                { (this.props.is_admin === 1 || data.is_admin === '1') && (
                    <div className={style.adminAction}>
                        {this.props.needApprove && this.props.is_admin === 1 && (
                            <div className={style.iconAction}>
                                <ActionBtn action={() => {
                                    this.setState({
                                        loadingApprove: true
                                    })
                                    this.props.onApprove()
                                }} style={{
                                        width: '110px',
                                        }} loading={this.state.loadingApprove} size='10' theme='semi-rounded-orange'>
                                    {T.txt('c_approve')}
                                </ActionBtn>
                            </div>
                        )}
                        {this.props.actionEdit && (
                            <div className={style.iconAction}>
                                <ActionBtnIcon size='30' icon='edit' theme='rounded-orange' action={() => { this.props.actionEdit(data.id) }} />
                            </div>
                        )}
                        {this.props.actionDelete && (
                            <div className={style.iconAction}>
                                <ActionBtnIcon size='30' icon='trash' theme='rounded-orange' action={() => { this.props.actionDelete(data.id) }} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Timeline/Containers/Header/index.js